<template>
  <div class="toolbar-wrapper" :class="{ 'collapsed': isCollapsed }">
    <!-- 工具栏头部 -->
    <div class="toolbar-header">
      <!-- 顶部按钮栏（这里暂时不需要按钮，只留占位） -->
      <div class="toolbar-buttons" v-show="!isCollapsed">
      </div>
      <!-- 收缩/展开按钮 -->
      <button class="collapse-btn" @click="toggleCollapse" :title="isCollapsed ? '展开工具栏' : '收缩工具栏'" :class="{ 'expanded': !isCollapsed }">
        <div class="collapse-arrow" :class="{ 'up': isCollapsed }">▼</div>
      </button>
    </div>
    
    <!-- 类型选择按钮 -->
    <div class="type-buttons" v-show="!isCollapsed">
      <button 
        v-for="type in dramaTypes" 
        :key="type.value"
        class="type-btn"
        :class="{ 'active': currentDramaType === type.value }"
        @click="selectDramaType(type.value)"
      >
        {{ type.label }}
      </button>
    </div>
    
    <!-- 提示词输入区 -->
    <div class="prompt-input-container">
      <textarea 
        v-model="form.prompt" 
        class="prompt-input" 
        placeholder="输入剧本内容或提示词..."
        rows="3"
      ></textarea>
    </div>
    
    <!-- 底部参数选项 -->
    <div class="toolbar-options" v-show="!isCollapsed">
      <!-- 时长选择 -->
      <div class="option-group">
        <select v-model="form.duration" class="option-select">
          <option value="1分钟">1分钟</option>
          <option value="3分钟">3分钟</option>
          <option value="5分钟">5分钟</option>
          <option value="10分钟">10分钟</option>
        </select>
      </div>
      
      <!-- 风格选择 -->
      <div class="option-group">
        <select v-model="form.genre" class="option-select">
          <option value="剧情">剧情</option>
          <option value="喜剧">喜剧</option>
          <option value="悬疑">悬疑</option>
          <option value="奇幻">奇幻</option>
        </select>
      </div>
      
      <!-- 图片上传按钮组 -->
      <div class="upload-group">
        <!-- 首帧上传 -->
        <div class="mini-upload-box">
          <input ref="startFrameInput" type="file" accept="image/*" style="display: none" @change="handleStartFrameUpload">
          <div class="mini-preview" @click="openStartFrameUpload">
            <img v-if="startFrameData" :src="startFrameData" alt="首帧" class="mini-preview-img">
            <span v-else class="mini-label">首帧</span>
          </div>
          <button v-if="startFrameData" class="mini-remove" @click.stop="removeStartFrame">×</button>
        </div>
        
        <!-- 尾帧上传 -->
        <div class="mini-upload-box">
          <input ref="endFrameInput" type="file" accept="image/*" style="display: none" @change="handleEndFrameUpload">
          <div class="mini-preview" @click="openEndFrameUpload">
            <img v-if="endFrameData" :src="endFrameData" alt="尾帧" class="mini-preview-img">
            <span v-else class="mini-label">尾帧</span>
          </div>
          <button v-if="endFrameData" class="mini-remove" @click.stop="removeEndFrame">×</button>
        </div>
        
        <!-- 角色上传（横向排列） -->
        <div class="roles-group">
          <!-- 已上传的角色 -->
          <div 
            v-for="(frame, index) in keyFrames" 
            :key="index"
            class="mini-upload-box role-box"
          >
            <div class="mini-preview role-preview">
              <img :src="frame.data" :alt="`角色${index + 1}`" class="mini-preview-img">
            </div>
            <button class="mini-remove" @click.stop="removeRole(index)">×</button>
          </div>
          
          <!-- 添加按钮（小于3张时显示） -->
          <div 
            v-if="keyFrames.length < 3" 
            class="mini-upload-box add-box"
            @click="openKeyFramesUpload"
          >
            <div class="mini-preview add-preview">
              <span v-if="keyFrames.length === 0" class="mini-label">角色</span>
              <span v-else class="add-icon">+</span>
            </div>
          </div>
          
          <!-- 隐藏的上传input -->
          <input ref="keyFramesInput" type="file" accept="image/*" style="display: none" @change="handleKeyFramesUpload">
        </div>
      </div>
      
      <!-- 生成按钮 -->
      <button class="generate-btn" @click="generateDrama" :disabled="isGenerating">
        <span v-if="!isGenerating">生成短剧</span>
        <span v-else>生成中...</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DramaToolbar',
  props: {},
  data() {
    return {
      isGenerating: false,
      isCollapsed: false,
      startFrameData: null,
      startFrameName: '',
      endFrameData: null,
      endFrameName: '',
      keyFrames: [],
      currentDramaType: 'normal',
      dramaTypes: [
        { label: '常规短剧', value: 'normal' },
        { label: '2D动画', value: '2d' },
        { label: 'CG动漫', value: 'cg' }
      ],
      form: {
        prompt: '',
        duration: '3分钟',
        genre: '剧情'
      }
    }
  },
  mounted() {
  },
  methods: {
    selectDramaType(type) {
      this.currentDramaType = type;
    },
    
    openStartFrameUpload() {
      this.$refs.startFrameInput.click();
    },
    
    handleStartFrameUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.startFrameName = file.name;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.startFrameData = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    
    removeStartFrame() {
      this.startFrameData = null;
      this.startFrameName = '';
      this.$refs.startFrameInput.value = '';
    },
    
    openEndFrameUpload() {
      this.$refs.endFrameInput.click();
    },
    
    handleEndFrameUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.endFrameName = file.name;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.endFrameData = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    
    removeEndFrame() {
      this.endFrameData = null;
      this.endFrameName = '';
      this.$refs.endFrameInput.value = '';
    },
    
    openKeyFramesUpload() {
      if (this.keyFrames.length >= 3) {
        alert('最多上传3张角色');
        return;
      }
      this.$refs.keyFramesInput.click();
    },
    
    handleKeyFramesUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (this.keyFrames.length < 3) {
            this.keyFrames.push({
              name: file.name,
              data: e.target.result
            });
          }
        };
        reader.readAsDataURL(file);
      }
    },
    
    removeRole(index) {
      this.keyFrames.splice(index, 1);
    },
    
    generateDrama() {
      if (!this.form.prompt.trim()) {
        alert('请输入剧本或提示词');
        return;
      }
      
      let mergedPrompt = this.form.prompt
      
      if (this.form.duration) {
        mergedPrompt += `，时长：${this.form.duration}`
      }
      
      if (this.form.genre) {
        mergedPrompt += `，风格：${this.form.genre}`
      }
      
      const dramaTypeLabel = this.dramaTypes.find(t => t.value === this.currentDramaType)?.label || '常规短剧'
      mergedPrompt += `，类型：${dramaTypeLabel}`
      
      this.isGenerating = true;
      
      // 平滑滚动到顶部，让用户看到生成过程
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      setTimeout(() => {
        this.isGenerating = false;
        
        const newDrama = {
          prompt: mergedPrompt,
          duration: this.form.duration,
          genre: this.form.genre,
          script: mergedPrompt,
          startFrame: this.startFrameData,
          endFrame: this.endFrameData,
          keyFrames: this.keyFrames.map(f => f.data),
          videoUrl: '',
          thumbnail: this.startFrameData || `https://trae-api-cn.mchost.guru/api/ide/v1/text-to-image?prompt=${encodeURIComponent(mergedPrompt)}&image-size=square_hd`,
          generating: false,
          progress: 0,
          generateTime: this.getCurrentTime(),
          startFrameRatio: '16:9',
          endFrameRatio: this.endFrameData ? '16:9' : null
        };
        
        this.$emit('add-drama', newDrama);
      }, 2000);
    },
    
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
};
</script>

<style scoped>
.toolbar-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  transition: all 0.3s ease;
}

.toolbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 0;
  position: relative;
  overflow: visible;
}

.toolbar-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.collapse-btn {
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #4ade80;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.collapse-btn.expanded {
  color: #ff4757;
}

.collapse-btn:hover {
  transform: translate(-50%, -50%) scale(1.1);
}

.collapse-arrow {
  transition: transform 0.3s ease, color 0.3s ease;
  font-size: 14px;
  font-weight: bold;
}

.collapse-arrow.up {
  transform: rotate(180deg);
}

.toolbar-wrapper.collapsed {
  height: 0;
  overflow: visible;
}

.toolbar-wrapper.collapsed .prompt-input-container,
.toolbar-wrapper.collapsed .toolbar-options {
  display: none;
}

.toolbar-wrapper.collapsed .toolbar-header {
  align-items: center;
  justify-content: center;
}

.prompt-input-container {
  width: 100%;
}

.prompt-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 12px;
  color: #e6f1ff;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  min-height: 80px;
  box-sizing: border-box;
}

.prompt-input::placeholder {
  color: #8892b0;
}

.type-buttons {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  margin-top: 0;
  padding-top: 0;
}

.type-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 8px 16px;
  color: #8892b0;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.type-btn:hover {
  background: rgba(0, 230, 172, 0.15);
  border-color: rgba(0, 230, 172, 0.4);
  color: #00e6ac;
}

.type-btn.active {
  background: rgba(0, 230, 172, 0.2);
  border-color: rgba(0, 230, 172, 0.6);
  color: #00e6ac;
  font-weight: 500;
}

.toolbar-options {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.option-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.option-select {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 8px 12px;
  color: #e6f1ff;
  font-size: 14px;
  min-width: 100px;
  cursor: pointer;
}

.option-select option {
  background: #0a192f;
  color: #e6f1ff;
}

.upload-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.roles-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.mini-upload-box,
.key-frames-box {
  position: relative;
}

.role-box {
  position: relative;
}

.role-preview {
  overflow: hidden;
}

.add-box {
  cursor: pointer;
}

.add-preview {
  border-style: dashed;
  border-color: rgba(0, 230, 172, 0.3);
}

.add-preview:hover {
  border-color: rgba(0, 230, 172, 0.6);
  background: rgba(0, 230, 172, 0.05);
}

.add-icon {
  font-size: 20px;
  color: rgba(0, 230, 172, 0.5);
  line-height: 1;
  font-weight: 300;
}

.add-preview:hover .add-icon {
  color: rgba(0, 230, 172, 0.8);
}

.mini-preview {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.mini-preview:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(100, 255, 218, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(100, 255, 218, 0.2);
}

.mini-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mini-label {
  font-size: 12px;
  color: #8892b0;
  line-height: 1;
  font-weight: 500;
}

.mini-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border: none;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  z-index: 10;
}

.mini-remove:hover {
  background: #ff4757;
  transform: scale(1.1);
}

.generate-btn {
  background: #00e6ac;
  color: #000;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: auto;
  white-space: nowrap;
}

.generate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 230, 172, 0.3);
}

.generate-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .toolbar-options {
    flex-direction: column;
    align-items: stretch;
  }
  
  .upload-group {
    justify-content: center;
  }
  
  .generate-btn {
    margin-left: 0;
  }
}
</style>
